<script>
import DropDown from "../reUse/DropDown.vue"
import Notification from "../reUse/Notification.vue"
import { i18n } from '@/i18n'
import sl from '@/Prevodi/Nalogi-sl.json';
import en from '@/Prevodi/Nalogi-en.json';
import it from '@/Prevodi/Nalogi-it.json';
import {config} from "@/config";
export default {
  components: {
    DropDown,
    Notification
  },
  emits: ['odjava'],
  data() {
    return {
      prevodi: false,
      datum: new Date().toISOString().split('T')[0],
      pilotName: '',
      regLetala: '',
      letaloID: null,
      regRocno: false,
      tipLetala: '',
      potniki: [],
      Licenca: '',
      // stNaloga: '',
      Namen: '',
      Ruta: '', //JAz bi dal avto LJAJ - LJAJ ampak to ni GENERIČNO!!!
      PodatekZaPDF: '',
      // krajVzleta: 'LJAJ',
      // krajPristanka: 'LJAJ',
      Letalisca: [],
      Letala: [],
      Piloti: [],
      formatPotnik: [],
      // Instruktor: [],
      dPilot: false,
      dLetalo: false,
      dVzlet: false,
      dPristanek: false,
      //NOTIFICATION
      ShowNoti: false,
      text: '',
      types: '',
      indexBrisanja: 0,
      isLoading: false,
      user: config.FullUser.id,
      FullUser: config.FullUser,
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.GetLetalisca();
    this.GetLetala();
    this.GetPiloti();
  },
  methods: {
    GetLetalisca() {
      let app = this;
      axios
          .get("./api/sifranti/letalisca/beri/")
          .then(function (response) {
            app.Letalisca = response.data;
          })
          .catch(function (napaka) {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = "Napaka";
            this.ShowNoti = true;
          })
    },
    GetLetala() {
      let app = this;
      axios
          .get("./api/sifranti/letala/izpis/")
          .then(function (response) {
            for (let i = 0; i < response.data.letala.length; i++) {
              if (response.data.letala[i].vrsta_letala === 'Motorno' || response.data.letala[i].vrsta_letala === 'Ultralight') {
                app.Letala.push(response.data.letala[i]);
              }
            }
            // app.Letala = response.data;
          })
          .catch(function (napaka) {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = "Napaka";
            this.ShowNoti = true;
          })
    },
    GetPiloti() {
      let app = this;
      axios
          .get("./api/sifranti/piloti/izpis/")
          .then((response) => {
            this.Piloti.piloti = response.data.piloti.filter(pilot => pilot.email === this.FullUser.email);
          })
          .catch(function (napaka) {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = "Napaka";
            this.ShowNoti = true;
          })
    },
    selectPilot(id) {
      let pilot = this.Piloti.piloti.find(p => p.id === id);
      if (pilot) {
        this.pilotName = pilot.ime + ' ' + pilot.priimek;
        this.Licenca = (pilot.licenca || '').trim();
        // this.pilotName = pilot.sifra;
        this.dPilot = false;
      }
    },
    selectLetalo(id) {
      // let letalo = this.Letala.letala.find(l => l.id === id);
      let letalo = this.Letala.find(l => l.id === id);
      if (letalo) {
        this.regLetala = letalo.registracija;
        this.letaloID = id;
        this.dLetalo = false; // Zapri dropdown po izbiri
      }
    },
    selectPristanek(id) {
      let pristanek = this.Letalisca.letalisca.find(pr => pr.id === id);
      if (pristanek) {
        this.dPristanek = false;
        this.krajPristanka = pristanek.icao;
      }
    },
    selectVzlet(id) {
      let vzlet = this.Letalisca.letalisca.find(vl => vl.id === id);
      if (vzlet) {
        this.dVzlet = false;
        this.krajVzleta = vzlet.icao;
      }
    },
    OpenPilot() {
      this.dPilot = !this.dPilot;
    },
    OpenLetalo() {
      this.dLetalo = !this.dLetalo;
    },
    OpenVzlet() {
      this.dVzlet = !this.dVzlet;
    },
    OpenPristanek() {
      this.dPristanek = !this.dPristanek;
    },
    DodajPotnika() {
      if (this.potniki.length <= 15) {
        this.potniki.push({ime: ''});
      }
    },
    OdstraniPotnika(index) {
      this.text = this.$t('obvestila.vprasanjeBrisa');
      this.types = 'Vprašanje';
      this.ShowNoti = true;
      this.indexBrisanja = index;
    },
    OdgovoriDa() {
      this.potniki.splice(this.indexBrisanja, 1);
      this.ShowNoti = false;
    },
    CheckInputs(inputsArray) {
      //funkcija, ki preveri "obvezne" inpute in jih obarva rdeče, če niso nastavljeni
      for (var i = 0; i < inputsArray.length; i++) {
        if (this[inputsArray[i]] === '') {
          // console.log(inputsArray[i]); //samo za dev
          $('#' + inputsArray[i]).addClass('required-field');
        } else {
          $('#' + inputsArray[i]).removeClass('required-field');
        }
      }
    },
    ResetRequired(inputsArray) {
      for (var i = 0; i < inputsArray.length; i++) {
        $('#' + inputsArray[i]).removeClass('required-field');
      }
    },
    posljiOdobritev() {
      if (this.Ruta === '' || this.licenca === '' || this.tipLetala === '' || this.pilotName === '' || this.regLetala === '') {
        var requiredPolja = ['Ruta', 'licenca', 'tipLetala', 'pilotName', 'regLetala'];
        this.CheckInputs(requiredPolja);
        this.text = this.$t('obvestila.napakaInputa');
        this.types = 'Napaka';
        this.ShowNoti = true;
      } else {
        this.isLoading = true;
        let podatki = new URLSearchParams();
        podatki.append("datum", this.datum);
        for (var i = 0; i < this.potniki.length; i++) {
          if (this.potniki[i].ime !== '') {
            this.formatPotnik.push(this.potniki[i].ime);
          }
        }
        podatki.append("potniki", JSON.stringify(this.formatPotnik));
        podatki.append("licenca", this.Licenca);
        podatki.append("tip", this.tipLetala);
        podatki.append("pilot", this.pilotName);
        podatki.append("registracija", this.regLetala);
        podatki.append("id_letala", this.letaloID);
        podatki.append("ruta", this.Ruta);
        // podatki.append("st_nalog", this.stNaloga);
        podatki.append("namen", this.Namen);
        axios
            .post("./api/flightorder/pdf/", podatki)
            .then((response) => {
              this.PodatekZaPDF = response.data.datoteka;
              if (this.PodatekZaPDF !== '') {
                let podatki = new URLSearchParams();
                podatki.append('zadeva', 'NAROČILO LETA');
                podatki.append('datoteka', this.PodatekZaPDF);
                podatki.append("id_letala", this.letaloID);
                axios
                    .post("./api/log/mail/", podatki)
                    .then((response) => {
                      // console.log(response);
                    })
                    .catch((napaka) => {
                      if (napaka.response.status === 401) {
                        this.$router.push('/Logout');
                      }
                      if (napaka.response.data.napaka !== undefined) {
                        this.text = this.$t('obvestila.napakaPosiljanja');
                      } else {
                        this.text = this.$t('obvestila.napakaPosiljanja');
                      }
                      this.types = 'Napaka';
                      this.ShowNoti = true;
                      this.isLoading = false;
                    })
              }
              // console.log(this.PodatekZaPDF);
              this.text = this.$t('obvestila.uspesnoPoslan');
              this.types = 'Uspešno';
              this.ShowNoti = true;
              this.isLoading = false;
              //po-nastavitev podatkov
              this.formatPotnik = [];
              this.potniki = [];
              this.Licenca = '';
              this.tipLetala = '';
              this.pilotName = '';
              this.regLetala = '';
              this.letaloID = null;
              this.Ruta = '';
              // this.stNaloga = '';
              this.Namen = '';
              var requiredPolja = ['Ruta', 'licenca', 'tipLetala', 'pilotName', 'regLetala'];
              this.ResetRequired(requiredPolja);
            })
            .catch((napaka) => {
              if (napaka.response.status === 401) {
                this.$router.push('/Logout');
              }
              if (napaka.response.data.napaka !== undefined) {
                this.text = this.$t('obvestila.napakaPosiljanja');
              } else {
                this.text = this.$t('obvestila.napakaPosiljanja');
              }
              this.types = 'Napaka';
              this.ShowNoti = true;
              this.isLoading = false;
            })
      }
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="pregled-povrsin-container" v-if="prevodi">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{$t('main.nazaj')}}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{$t('main.title')}}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </div>
  <!-- <div class='text-center'>
      <span class='btn btn-sm text-white' :class="{'border-bottom': this.prikaz == 'vnosi'}" @click.prevent="this.prikaz = 'vnosi'">Vnos</span> | <span class='btn btn-sm text-white' :class="{'border-bottom': this.prikaz == 'branje'}" @click.prevent="this.prikaz = 'branje'">Dnevnik</span>
  </div> -->
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="OdgovoriDa()" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
  </Transition>
  <div class="col-12">
    <div class="container">
      <div class="label-date p-2 col-6" for="datum">{{$t('labels.datum')}}</div>
      <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" v-model="datum" required />
    </div>
  </div>
  <!-- ŠT. NALOGA-->
  <!-- <div class="col-12">
      <div class="container">
          <label :class="{ hidden: stNaloga.length > 0 }" class="label-time p-2" for="stNaloga">Številka naloga :</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="text" inputmode="numeric" maxlength="" placeholder="NAŠTIMAMO AVTOMATSKO" id="stNaloga" v-model="stNaloga" required />
      </div>
  </div> -->
  <div class="col-12">
    <!-- <div class="container">
        <label :class="{ hidden: pilotName.length > 0 }" class="label" for="pilotName">Pilot / Učenec</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="pilotName" v-model="pilotName" required />
    </div> -->
    <div class="container">
      <label class="label-dropdown" for="pilotName">{{$t('labels.pilot')}} <button v-if="pilotName !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="pilotName = ''; Licenca = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
      <div class="drop-down-icon text-black" @click.prevent="OpenPilot()">
        <i v-show="!dPilot" class="fas fa-chevron-right"></i>
        <i v-show="dPilot" class="fas fa-chevron-down"></i>
      </div>
      <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="pilotName" @click.prevent="OpenPilot">{{pilotName}}</button>
      <transition name="fade">
        <drop-down @pilot="selectPilot" :data="Piloti" type="piloti" class="drop-down-btn" v-if="dPilot" />
      </transition>
    </div>
  </div>
  <!-- REGISTRACIJA -->
  <div class="col-12">
    <div class="container">
      <label :class="{ hidden: regLetala.length > 0 }" class="label-time p-2" for="regLetala">{{$t('labels.reg')}}</label><br/>
      <label class="label-time p-2" for="regLetala">Ročni vnos registracije ? &nbsp;<input type='checkbox' v-model='regRocno'></label><br/>
      <!-- ROČNI VNOS REGISTRACIJE -->
      <input class="input border-0 rounded-4 p-2 fs-5" type="text" placeholder="S5-XYZ" id='regLetala' v-model="regLetala" v-if="regRocno" required />
      <!-- SELECT LETALA -->
      <label v-if="!regRocno" class="label-dropdown" for="regLetala">Izberi registracijo letala : <button v-if="regLetala !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="regLetala = ''">Pobriši izbiro</button></label>
      <div v-if="!regRocno" class="drop-down-icon text-black" @click.prevent="OpenLetalo()">
        <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
        <i v-show="dLetalo" class="fas fa-chevron-down"></i>
      </div>
      <button v-if="!regRocno" class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" @click.prevent="OpenLetalo">{{regLetala}}</button>
      <transition v-if="!regRocno" name="fade">
        <drop-down @letalo="selectLetalo" :data="Letala" type="letalo" class="drop-down-btn" v-if="dLetalo" />
      </transition>
    </div>
  </div>
  <!-- MODEL, VARIANTA ZRAKOPLOVA-->
  <div class="col-12">
    <div class="container">
      <label :class="{ hidden: tipLetala.length > 0 }" class="label-time p-2" for="tipLetala">{{$t('labels.tip')}}</label>
      <input class="input border-0 rounded-4 p-2 fs-5" type="text" placeholder="PA18, PIVI,.." id="tipLetala" v-model="tipLetala" required />
    </div>
  </div>
  <!-- LICENA-->
  <div class="col-12">
    <div class="container">
      <label :class="{ hidden: Licenca.length > 0 }" class="label-time p-2" for="Licenca">{{$t('labels.licenca')}}</label>
      <input class="input border-0 rounded-4 p-2 fs-5" type="text" inputmode="numeric" maxlength="" placeholder="FCL.." id="Licenca" v-model="Licenca" required />
    </div>
  </div>
  <!-- RUTA -->
  <div class="col-12">
    <div class="container">
      <label :class="{ hidden: Ruta.length > 0 }" class="label-time p-2" for="Ruta">{{$t('labels.ruta')}}</label>
      <input class="input border-0 rounded-4 p-2 fs-5" type="text" inputmode="text" maxlength="" placeholder="LJAJ - LJPZ.." id="Ruta" v-model="Ruta" required />
    </div>
  </div>
  <div class="col-12">
    <div class="container">
      <label :class="{ hidden: Namen.length > 0 }" class="label-time p-2" for="Ruta">{{$t('labels.namen')}}</label>
      <input class="input border-0 rounded-4 p-2 fs-5" type="text" inputmode="text" maxlength="" placeholder="Ruta.." id="Namen" v-model="Namen" required />
    </div>
  </div>
  <!-- POTNIKI  -->
  <div class="col-12">
    <div class="container p-2">
      <button class="btn btn-outline-success rounded" @click.prevent="DodajPotnika()">{{$t('buttons.dodajPotnika')}}</button>
    </div>
    <TransitionGroup name="fade">
      <div v-for="(potnik, index) in potniki" class="container shadow p-2 rounded" :key="index">
        <div :class="{ hidden: potnik.ime.length > 0 }" class="label-time">Potnik:{{index + 1}} - <button class="btn btn-outline-danger rounded btn-sm" @click.prevent="OdstraniPotnika(index)"><i  class="far fa-minus fa" ></i></button></div>
        <label :class="{ hidden: potnik.ime.length > 0 }" class="label-time p-2" for="potnik-ime-{{index}}">{{$t('labels.potnik')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="{{index}}" v-model="potniki[index].ime" required />
        <!-- <label :class="{ hidden: potnik.priimek.length > 0 }" class="label-time p-2" for="potnik-priimek-{{index}}">Priimek potnika :</label> -->
        <!-- <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="potnik-priimek-{{index}}" v-model="potnik.priimek" required /> -->
      </div>
    </TransitionGroup>
  </div>
  <div class="container p-2">
    <button @click.prevent="posljiOdobritev()" class="btn btn-primary rounded-pill btn-add col-12">
      <div v-if="!isLoading">{{$t('buttons.posljiOdobritev')}}</div>
      <div v-else class="spinner-border text-light" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>
  </div>
  <div class='col-12 p-5'></div>
</template>